module.exports = __webpack_public_path__ + "img/qx.866fb678.svg";